module.exports = __webpack_public_path__ + "img/BaliBody4.dd38f073.jpg";